import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { LostConnection, NotFoundDataConn } from '../../constant';
import { getAllBranches } from '../../services/commercialLine/commercialLine';

export const usePrinterPoints = () => {
    
    const history = useHistory();

    const [printerPoints, setPrinterPoints] = useState([]);
    const [printerPointId, setPrinterPointId] = useState(0);

    const [method, setMethod] = useState("");
    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [branches, setBranches] = useState([]);

        // ? Delete dialog
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);

    const [searchPrintPoint, setSearchPrintPoint] = useState("");
    const [printerPointsBackup, setPrinterPointsBackup] = useState([]);

    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues] = useForm({
        name: "",
        username: "",
        password: "",
        password_confirmation: "",
        mSelectBranch: 0,
    });

    const { name, username, password, password_confirmation, mSelectBranch } = formValues;

    const [validaciones, setValidaciones] = useState({
        name: false,
        username: false,
        password: false,
        password_confirmation: false,
        mSelectBranch: false
    });

    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

   
     const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false); 
        setModalAlert(false);   
    };

    const getPrintetProints = useCallback(
        async () => {
            let requestOptions = {
                method: 'GET'
            };

            const respuesta = await sendRequest(requestOptions, "PrinterPoints");

            if (respuesta.code === 200) {
                setPrinterPoints(respuesta.data);
                setPrinterPointsBackup(respuesta.data); //
            }
            else{
                validarSesion(history, respuesta.code, getPrintetProints);
            }
        },
        [history]
    )

    useEffect(() => {
        getPrintetProints();
    }, [getPrintetProints])

    const handleCreate = () => {
        
        setValidaciones({
            name: false,
            username: false, 
            password: false,
            password_confirmation: false,
            mSelectBranch: false,
        });

        handleUpdateValues({
            name: "",
            username: "",
            password: "",
            password_confirmation: "",
            mSelectBranch: "",
        });

        setPrinterPointId(0);
        setMethod("create");
        setModalTitle("Creación de punto de impresión");
        openDialog("Crear punto de impresión", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        if (validarForm()) {
            return;
        }

        setLoading(true);

        const data = {
            id_branch: mSelectBranch?.value || 0, 
            name,
            username,
            password
        };


        let raw = JSON.stringify(data);
        let requestOptions = {
            method: 'POST',
            body: raw
        };

        const respuesta = await sendRequest(requestOptions, 'PrinterPoints');

        if (respuesta.code === 200) {
            let newPrinterPoints = [...printerPoints];
            newPrinterPoints.push({
                id_printer_point: respuesta.data.id_printer_point,
                name: name,
                username: username,
                id_branch: mSelectBranch?.value,


            });
            

            setPrinterPoints(newPrinterPoints);
            reset();
            createSweet("create","success", "Exito!", "Se creo el punto de impresión");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
            setLoading(false);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Método de pago", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else{
            setLoading(false);
            createSweet("error", "warning", "Método de pago", respuesta.data.msg);
        }
    }

    const handleUpdate = (id_printer_point) => {
        let printerPoint = printerPoints.find(x => x.id_printer_point === id_printer_point);
        const branchOption = branches.find(branch => branch.value === printerPoint.id_branch) || null;

        handleUpdateValues({
            name: printerPoint.name,
            username: printerPoint.username,
            password: "",
            password_confirmation: "",
            mSelectBranch: branchOption  
        });

        setValidaciones({
            name: false,
            username: false,
            password: false,
            password_confirmation: false,
            mSelectBranch: false
        });

        setPrinterPointId(id_printer_point);
        setMethod("update");
        setModalTitle("Actualización de punto de impresión");
        openDialog("Editar punto de impresión", "update"); 
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        if (validarForm()) {
            return;
        }
        
        setLoading(true);

        let body = {
            id_printer_point: printerPointId,
            name: formValues.name,
            username: formValues.username,
            password: formValues.password,
            password_confirmation: formValues.password_confirmation,
            id_branch: formValues.mSelectBranch?.value ?? null
        };


        let raw = JSON.stringify(body);
        
        let requestOptions = {
            method: 'PUT',
            body: raw,
        };

        const respuesta = await sendRequest(requestOptions, "PrinterPoints");

        if (respuesta.code === 200) {
            
            let newPrinterPoints = printerPoints.map(obj => {
            if (obj.id_printer_point === printerPointId) {
                return {
                    ...obj,
                    name: formValues.name,
                    username: formValues.username,
                    id_branch: formValues.mSelectBranch?.value ?? obj.id_branch
                };
            }
            return obj;
        });
            
            setPrinterPoints(newPrinterPoints);
            createSweet("update", "success", "Exito!", "Se actualizo el punto de impresión");
            setLoading(false);
            closeDialog();
        } else {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }

    const handleDelete = (id_printer_point) => {
        let printerPoint = printerPoints.find(x => x.id_printer_point === id_printer_point);
        
        handleUpdateValues({
            name: printerPoint.name,
        });
        
        setPrinterPointId(id_printer_point);
        setMethod("delete");
        setModalTitle("Eliminar punto de impresión");
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE',
        };

        const respuesta = await sendRequest(requestOptions, `PrinterPoints/${printerPointId}`);
        
        if (respuesta.code === 200) {
            let newPrinterPoints = printerPoints.filter(x => x.id_printer_point !== printerPointId);
            
            setPrinterPoints(newPrinterPoints);
            setLoading(false);
            createSweet("delete", "success", "Exito!", "Se elimino correctamente");
            closeDeleteAlert();
        } 
        else {
            validarSesion(history, respuesta.code, saveDelete);
        }
    }

    const validarForm = () => {
        let statusValidacion = false;
        let newValidaciones = {};

        if (formValues.name.length < 3) {
            newValidaciones = {
                ...newValidaciones,
                name: true
            }
            statusValidacion = true;
        } 
        else {
            newValidaciones = {
                ...newValidaciones,
                name: false
            }
        }

        if (formValues.username.length < 3) {
            newValidaciones = {
                ...newValidaciones,
                username: true
            }
            statusValidacion = true;
        } 
        else {
            newValidaciones = {
                ...newValidaciones,
                username: false
            }
        }

        if (formValues.password.length < 8) {
            newValidaciones = {
                ...newValidaciones,
                password: true
            }
            statusValidacion = true;
        } 
        else {
            newValidaciones = {
                ...newValidaciones,
                password: false
            }
        }

        if (password !== password_confirmation) {
            newValidaciones = {
                ...newValidaciones,
                password_confirmation: true
            }
            statusValidacion = true;
        } 
        else {
            newValidaciones = {
                ...newValidaciones,
                password_confirmation: false
            }
        }

        if (!formValues.mSelectBranch || !formValues.mSelectBranch.value) {
            newValidaciones = {
                ...newValidaciones,
                mSelectBranch: true
            }
            statusValidacion = true;
        } else {
            newValidaciones = {
                ...newValidaciones,
                mSelectBranch: false
            }
        }

        

        setValidaciones(newValidaciones)

        return statusValidacion;
    }

    useEffect(() => {
        getBranches();
    }, [])


    const getBranches = async () => {
        const branches = await getAllBranches();
        if (branches !== null && branches.length > 0) {
            let _newBranches = []; 
    
            branches.forEach((branch) => {
                _newBranches.push({
                    value: branch.id_branch,
                    label: branch.name
                });
            });
    
            setBranches(_newBranches);
        } else {
            setBranches([]);
        }
    }

    const handleExcelPrintPoint = async () => {
        setLoadingExcel(true); 

        try {
            const XLSX = await import("xlsx");

            const data = printerPoints.map((item, index) => {
                const branch = branches.find(b => b.value === item.id_branch);

                return {
                    "#": index + 1,
                    "Nombre": item.name || "----",
                    "Usuario": item.username || "----",
                    "Sucursal": branch ? branch.label : "----"
                };
            });

            const worksheet = XLSX.utils.json_to_sheet(data);

            worksheet["!cols"] = [
                { wch: 5 },   // #
                { wch: 30 },  // Nombre
                { wch: 25 },  // Usuario
                { wch: 30 }   // Sucursal
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Puntos de impresión");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Catalogo_Puntos_Impresion.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExcel(false); 
    };


const handleSearchPrintPoint = (e) => {

    const value = e?.target?.value || e?.value || e || "";

    const search = value.toLowerCase();
    setSearchPrintPoint(search);

    if (!search) {
        setPrinterPoints(printerPointsBackup);
        return;
    }

    const filtered = printerPointsBackup.filter(item => {
        return (
            item.name?.toLowerCase().includes(search) ||
            item.username?.toLowerCase().includes(search)
        );
    });

    setPrinterPoints(filtered);
};

    const handleClearPrintPoint = () => {
        setSearchPrintPoint("");
         setPrinterPoints(printerPointsBackup);
    };

    return {
        printerPoints, method,
        name, username, password, password_confirmation, handleInputChange, validaciones,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        mSelectBranch, branches, handleSelectValues,
        modalAlert, closeDeleteAlert, showDeleteAlert,
        loadingExcel, handleExcelPrintPoint,
        handleSearchPrintPoint, searchPrintPoint,
        handleClearPrintPoint,
    }

}
